import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { extractErrorMessage } from '../../utils/extractErrorMessage'
import { useSnackbar } from 'notistack'
import { useDeleteWhatsappConfig } from '../../api/whatsapp-config'

const Delete = ({ openDelete, data, onClose, refetch }) => {
  const { mutateAsync, isLoading } = useDeleteWhatsappConfig()
  const { enqueueSnackbar } = useSnackbar()

  const handleDelete = async () => {
    try {
      await mutateAsync({ id: data._id })
      enqueueSnackbar('Successfully removed.', { variant: 'success' })
      onClose()
      refetch()
    } catch (e) {
      enqueueSnackbar(extractErrorMessage(e), { variant: 'error' })
    }
  }

  return (
    <Dialog maxWidth='sm' open={openDelete}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to remove{' '}
          <b>
            {data.displayName} ({data.phoneNumber})
          </b>
          ?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant='contained'
          style={{ background: 'red', color: 'white' }}
          onClick={handleDelete}
          disabled={isLoading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Delete
